import { render, staticRenderFns } from "./Central.vue?vue&type=template&id=39cc8ec3&scoped=true"
import script from "./Central.vue?vue&type=script&lang=js"
export * from "./Central.vue?vue&type=script&lang=js"
import style0 from "./Central.vue?vue&type=style&index=0&id=39cc8ec3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cc8ec3",
  null
  
)

export default component.exports